<template>
  <BDropdown text="My profile" variant="link">
    <BDropdownItem to="/orders">Orders &amp; downloads</BDropdownItem>
    <BDropdownItem to="/subscription">My subscription</BDropdownItem>
    <BDropdownItem to="/profile">My data</BDropdownItem>
    <BDropdownItem @click="onLogout">Logout</BDropdownItem>
  </BDropdown>
</template>

<script setup lang="ts">
import { BDropdown, BDropdownItem, useToast } from 'bootstrap-vue-next'
import { useAuthStore } from '@/stores/useAuthStore'
import { useRouter } from 'vue-router'

const authStore = useAuthStore()
const router = useRouter()
const { show: showToast } = useToast()

async function onLogout() {
  await authStore.logout()
  ;(window as any).$chatwoot?.reset()
  showToast?.({ props: { title: 'Success', body: 'Logout!', variant: 'success', value: true } })
  router.push({ name: 'login' })
}
</script>
